import { atom } from 'recoil';

export const currentPackageGroupAtom = atom({
    key: 'currentPackageGroupAtom',
    default: 'Default'
});
